/**
 * Cleans up booking history descriptions by removing raw MongoDB IDs
 * from assigned_area change descriptions.
 *
 * The space optimiser can produce descriptions like:
 * "Changed assigned area from id: 666c1c305cc82f000b152f12, name: Cocktail to
 *  id: 666c1c305cc82f000b152f12, name: Cocktail, zone: 6303543a87aa384ad258ad55"
 *
 * This strips `id: <24-char hex>`, `zone: <24-char hex>`, and `name:` label
 * patterns, leaving only the human-readable area names.
 */
export const cleanHistoryDescription = (description: string): string => {
  if (!description) return description;

  return description
    .replace(/\bid:\s*[a-f0-9]{24},?\s*/gi, "")
    .replace(/\bzone:\s*[a-f0-9]{24},?\s*/gi, "")
    .replace(/\bname:\s*/gi, "")
    .replace(/,(?=\s*(to\b|$))/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
};
